import menuDisplayByodApi from "api/menuDisplayManagerApi";
import menuDisplayManagerApi from "api/menuDisplayManagerApi";
import menuItemManagerApi from "api/menuItemManagerApi";
import productManagerApi from "api/productManagerApi";

export { useMenuDisplayManagerActions };

function useMenuDisplayManagerActions() {
   const getMainMenuDisplays = async (params) => {
      try {
         return await menuDisplayManagerApi.getMainMenuDisplay(params);
      } catch (error) {
         return []
      }
   };

   const getMenuDisplays = async (params) => {
      try {
         return await menuDisplayManagerApi.gets(params);
      } catch (error) {
         return []
      }
   };

   const getMenuDisplayById = async (params) => {
      try {
         return await menuDisplayManagerApi.get(params);
      } catch (error) {
         return []
      }
   };

   const getProductNoneItems = async (params) => {
      try {
         return await productManagerApi.getProductNoneItems(params);
      } catch (error) {
         return []
      }
   };

   const putMenuItemDisplay = async (body) => {
      try {
         return await menuItemManagerApi.putMenuItemDisplay(body);
      } catch (error) {
         return []
      }
   };

   const getMenuItemsNoneStore = async (params) => {
      try {
         return await menuItemManagerApi.getMenuItemsNoneStore(params);
      } catch (error) {
         return []
      }
   };

   const getGrandMenu = async (params) => {
      try {
         return await menuDisplayByodApi.getGrandMenu(params);
      } catch (error) {
         return []
      }
   };

   const getMainMenuDisplay = async (params) => {
      try {
         return await menuDisplayByodApi.getMainMenuDisplay(params);
      } catch (error) {
         return []
      }
   };

   const getMenuDisplayByParent = async (params) => {
      try {
         return await menuDisplayByodApi.getMenuDisplayByParent(params);
      } catch (error) {
         return []
      }
   };

   const getChildMenuOfMenuDisplay = async (params) => {
      try {
         return await menuDisplayByodApi.getMenuChildOfMenuDisplay(params);
      } catch (error) {
         return []
      }
   };

   const getMenus = async (params) => {
      try {
         return await menuDisplayByodApi.getMenus(params);
      } catch (error) {
         return []
      }
   };

   const getRecommends = async (params) => {
      try {
         return await menuDisplayByodApi.getRecommends(params);
      } catch (error) {
         return []
      }
   };

   return {
      getMainMenuDisplays,
      getMenuDisplays,
      getMenuDisplayById,
      getProductNoneItems,
      putMenuItemDisplay,
      getMenuItemsNoneStore,
      getGrandMenu,
      getMenuDisplayByParent,
      getMainMenuDisplay,
      getChildMenuOfMenuDisplay,
      getMenus,
      getRecommends
   };
}
